// 导入axios
import axios from 'axios';
import store from "@/store";
import { MessageBox,Message} from 'element-ui';
import { getToken } from "@/utils/auth";
import errorCode from "@/utils/errorCode";
import qs from "qs";
axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
//1. 创建新的axios实例，
const service = axios.create({
	// 公共接口--这里注意后面会讲
	baseURL: process.env.VUE_APP_BASE_API+'/store-web',
	// 超时时间 单位是ms，这里设置了3s的超时时间
	timeout: 3 * 1000
})
//2.请求拦截器
service.interceptors.request.use(
	config => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
		config.headers["Access-Control-Allow-Origin"] = '*';
		config.headers["Access-Control-Allow-Credentials"] = 'true';
		config.headers["Access-Control-Allow-Headers"] = 'DNT,X-Mx-ReqToken,Keep-Alive,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type, Accept-Language, Origin, Accept-Encoding';
		config.headers["Access-Control-Allow-Methods"] = '*';
		config.headers["Content-Type"] = 'application/x-www-form-urlencoded;charset=UTF-8'; //form-data

    if (getToken() && !isToken) {
		config.headers["Authorization"] = "Bearer " + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // get请求映射params参数
    if (config.method === "get" && config.params) {
		console.log(config.params)
		console.log('00000')
      let ret = "";
      ret = ret + "n=" + encodeURIComponent(Math.random());
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        // ie浏览器
        var url = config.url + "?" + ret + "&";
      } else {
        var url = config.url + "?";
      }

      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName];
        //encodeURIComponent 字符串作为url组件进行编码
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof value !== "undefined") {
          if (typeof value === "object") {
            for (const key of Object.keys(value)) {
              let params = propName + "[" + key + "]";
              var subPart = encodeURIComponent(params) + "=";
              url += subPart + encodeURIComponent(value[key]) + "&";
            }
          } else {
            url += part + encodeURIComponent(value) + "&";
          }
        }
      }
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
      // } else {
      //   if (config.method === 'get') {
      //     if (!!window.ActiveXObject || "ActiveXObject" in window) {
      //       // ie浏览器
      //       config.params = {
      //         _t: encodeURIComponent(Math.random()),
      //         ...config.params
      //       }
      //     }
      //   }
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);
// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // const code = 500
    // 获取错误信息
    // const msg = '保代系统温馨提示(平台编号ZC2523)：交强险：标准件,核保通过<br><br>商业险：R2:FAVCI4:脱保日期:车龄＞10年,验车，请上传影像-拒保<br>R2:FAVCI2:脱保日期:车龄＞10年，验车-非标<br>R2:FAVCI4:分级授权:分级授权0-拒保<br>'
    const msg = errorCode[code] || res.data.msg || errorCode["default"];
    if(code >= 500){
		Message({
			dangerouslyUseHTMLString: true,
			message: msg,
			showClose: true,
			type: "error",
			duration: 10000
		});
		return Promise.reject('error')
    }else if(code === 405) {
		// 登录失效
		MessageBox.confirm(
			"登录状态已过期，您可以继续留在该页面，或者重新登录",
			"温馨提示",
			{
			  confirmButtonText: "重新登录",
			  cancelButtonText: "取消",
			  type: "warning"
			}
		).then(() => {
			store.dispatch("LogOut").then(() => {
				location.href = "/login";
			});
        })
        .catch(() => { });
    }else if(code === 406) {
		//无权限
		Message({
			dangerouslyUseHTMLString: true,
			message: msg,
			showClose: true,
			type: "error",
			duration: 10000
		});
      return Promise.reject('error')
    }else if(code == 404) {
		Message({
			message: "温馨提示：请求错误",
			showClose: true,
			type: "error",
			duration: 10000
		});
		return Promise.reject('error')
    }else if(code == 300 || code == 302 || code == 303) {
		return res.data;
    }else if(code <= 300) {
		return res.data;
    }else{
		Message({
			dangerouslyUseHTMLString: true,
			message: msg,
			showClose: true,
			type: "error",
			duration: 10000
		});
		return Promise.reject('error')
    }
},
	error => {
		let { message } = error;
		if (message == "Network Error") {
			message = "温馨提示：服务挂起,请稍后重试! ";
		}else if(message.includes("timeout")) {
			message = "温馨提示：网络传输延迟，请刷新重试！";
		}else if(message.includes("Request failed with status code")) {
			message = "温馨提示：服务挂起,请稍后重试！";
		}
		Message({
			message: message,
			showClose: true,
			type: "error",
			duration: 10000
		});
		return Promise.reject(error)
	}
);

//4.导入文件
export default service
